export default () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.2793 4.88037C8.80443 4.37362 9.65212 4.37325 10.1777 4.88037C10.7098 5.39416 10.7099 6.23285 10.1777 6.74658L8.625 8.24463H13.6631C17.1513 8.24463 20.0009 10.9773 20.001 14.3735C20.0009 17.7698 17.1513 20.5024 13.6631 20.5024H6.45703C5.72462 20.5023 5.10848 19.9256 5.1084 19.189C5.1084 18.4523 5.72457 17.8756 6.45703 17.8755H13.6631C15.686 17.8755 17.3046 16.296 17.3047 14.3735C17.3045 12.4512 15.6858 10.8726 13.6631 10.8726H8.625L10.1777 12.3706C10.71 12.8843 10.7098 13.723 10.1777 14.2368C9.65232 14.7437 8.80462 14.7438 8.2793 14.2368L4.39844 10.4917C3.86668 9.97796 3.86657 9.13916 4.39844 8.62549L8.2793 4.88037Z"
      fill="currentColor"
    />
  </svg>
);
